import app from 'flarum/forum/app';
import extractText from 'flarum/common/utils/extractText';

// Mithril global.

/**
 * Mark every discussion read, as core's IndexPage toolbar button does: the same
 * confirm() prompt and the same save of `markedAllAsReadAt` on the user. Shared
 * by every copy of the action this theme draws (nav, footer).
 */
export default function markAllAsRead() {
  const user = app.session.user;
  if (!user) return;
  if (!confirm(extractText(app.translator.trans('core.forum.index.mark_all_as_read_confirmation')))) return;
  user.save({
    markedAllAsReadAt: new Date()
  }).then(() => {
    /*
     * The list has to be refetched: `markedAllAsReadAt` is on the USER, and the
     * discussions already in the store keep the unread counts they were loaded
     * with, so without this the action looks like it did nothing. Only a list
     * that has been loaded is refetched: clicked from the footer on a page that
     * never showed one, there is nothing stale and no request is needed.
     */
    if (app.discussions.hasItems()) app.discussions.refresh();
    m.redraw();
  });
}
flarum.reg.add('ernestdefoe-bespoke', 'forum/util/markAllRead', markAllAsRead);